import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axiosInstance from "../api/axiosConfig";

// Importa las imágenes desde la carpeta assets
import markerAutorizadoImg from "../assets/0emwie0m.png";
import markerNoAutorizadoImg from "../assets/nonAuthorized.png";

// Configuración de íconos usando las imágenes importadas
const authorizedIcon = L.icon({
  iconUrl: markerAutorizadoImg,
  iconSize: [30, 40],
  iconAnchor: [15, 40],
  popupAnchor: [0, -40],
});

const notAuthorizedIcon = L.icon({
  iconUrl: markerNoAutorizadoImg,
  iconSize: [30, 40],
  iconAnchor: [15, 40],
  popupAnchor: [0, -40],
});

const TalleresMap = () => {
  // Estados para almacenar los datos
  const [bodegas, setBodegas] = useState([]); // Autorizados
  const [talleresNoAutorizados, setTalleresNoAutorizados] = useState([]);

  // Estados de filtros
  const [filtroAutorizados, setFiltroAutorizados] = useState(true);
  const [filtroNoAutorizados, setFiltroNoAutorizados] = useState(true);
  const [filtroMecanica, setFiltroMecanica] = useState(true);
  const [filtroColisiones, setFiltroColisiones] = useState(true);

  useEffect(() => {
    // Cargar bodegas (autorizados)
    axiosInstance
      .get("/bodegas")
      .then((res) => setBodegas(res.data))
      .catch((err) => console.error("Error cargando bodegas:", err));

    // Cargar talleres no autorizados
    axiosInstance
      .get("/talleres-no-autorizados")
      .then((res) => setTalleresNoAutorizados(res.data))
      .catch((err) =>
        console.error("Error cargando talleres no autorizados:", err)
      );
  }, []);

  // Filtrar bodegas (autorizados) según especialidad
  const filtrarBodegas = () => {
    return bodegas.filter((bodega) => {
      if (bodega.especialidad === "MECANICA" && !filtroMecanica) {
        return false;
      }
      if (bodega.especialidad === "COLISIONES" && !filtroColisiones) {
        return false;
      }
      return true;
    });
  };

  // Filtrar talleres no autorizados según tipoTaller
  const filtrarNoAutorizados = () => {
    return talleresNoAutorizados.filter((taller) => {
      const tipo = taller.tipoTaller.toUpperCase();
      if (tipo.includes("COLISION") && !filtroColisiones) {
        return false;
      }
      if (tipo.includes("MECANIC") && !filtroMecanica) {
        return false;
      }
      return true;
    });
  };

  // Coordenadas iniciales (por ejemplo, Quito)
  const position = [-0.180653, -78.467834];
  const zoomLevel = 7;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Mapa de Talleres</h2>

      {/* Sección de filtros */}
      <div style={styles.filters}>
        <label style={styles.checkboxLabel}>
          <input
            type="checkbox"
            checked={filtroAutorizados}
            onChange={() => setFiltroAutorizados(!filtroAutorizados)}
          />
          Autorizados
        </label>
        <label style={styles.checkboxLabel}>
          <input
            type="checkbox"
            checked={filtroNoAutorizados}
            onChange={() => setFiltroNoAutorizados(!filtroNoAutorizados)}
          />
          No Autorizados
        </label>
        <label style={styles.checkboxLabel}>
          <input
            type="checkbox"
            checked={filtroMecanica}
            onChange={() => setFiltroMecanica(!filtroMecanica)}
          />
          Mecánica
        </label>
        <label style={styles.checkboxLabel}>
          <input
            type="checkbox"
            checked={filtroColisiones}
            onChange={() => setFiltroColisiones(!filtroColisiones)}
          />
          Colisiones
        </label>
      </div>

      {/* Contenedor del mapa: se fija una altura de 500px para asegurar la visibilidad */}
      <div style={styles.mapWrapper}>
        <MapContainer center={position} zoom={zoomLevel} style={styles.map}>
          <TileLayer
            attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {/* Marcadores de bodegas AUTORIZADAS */}
          {filtroAutorizados &&
            filtrarBodegas().map((bodega) => (
              <Marker
                key={bodega.codigo}
                position={[bodega.latitud, bodega.longitud]}
                icon={authorizedIcon}
              >
                <Popup>
                  <strong>{bodega.nombre}</strong>
                  <br />
                  Especialidad: {bodega.especialidad}
                  <br />
                  (Autorizado)
                </Popup>
              </Marker>
            ))}

          {/* Marcadores de talleres NO AUTORIZADOS */}
          {filtroNoAutorizados &&
            filtrarNoAutorizados().map((taller) => (
              <Marker
                key={taller.codigo}
                position={[taller.latitud, taller.longitud]}
                icon={notAuthorizedIcon}
              >
                <Popup>
                  <strong>{taller.nombre}</strong>
                  <br />
                  Tipo Taller: {taller.tipoTaller}
                  <br />
                  (No Autorizado)
                </Popup>
              </Marker>
            ))}
        </MapContainer>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    minHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f3f3f3",
    padding: "1rem",
  },
  title: {
    margin: 0,
    marginBottom: "1rem",
    textAlign: "center",
    color: "#333",
  },
  filters: {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    marginBottom: "1rem",
    justifyContent: "center",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
    fontSize: "0.9rem",
    cursor: "pointer",
  },
  mapWrapper: {
    height: "500px", // Fijamos una altura fija para el mapa
    border: "1px solid #ccc",
    borderRadius: "8px",
    overflow: "hidden",
  },
  map: {
    height: "100%",
    width: "100%",
  },
};

export default TalleresMap;
